import ConsoleHelper from 'src/shared/helpers/consoleHelper';
import { Box } from '@mui/material';
import { PageTemplate } from 'src/shared/templates/pageTemplate';
import { useTranslation } from 'react-i18next';
import { Purchase } from 'src/services/purchase.service';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/routes/routesEnum';
import PurchaseForm from './purchaseForm';
import PurchaseSummary from './purchaseSummary';
import PurchaseConfirmed from './purchaseConfirmed';

const RegisterPurchase = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [step, setStep] = useState<number>(1); // Step 1 = Form, Step 2 = Summary, Step 3 = Confirmed
  const [data, setData] = useState<Purchase>();
  const [imageData, setImageData] = useState<string>('');

  const setPurchaseData = (x: Purchase) => {
    ConsoleHelper.log('DATA', x);
    setData(x);
    setStep(2);
  };
  return (
    <PageTemplate
      title={step !== 3 ? t('registerPageTitle.purchased') : ''}
      subtitle={step === 1 ? t('typeSubtitle.enterInformationPurchased') : ''}
      showBackArrow={step !== 3}
      onClickBack={step === 2 ? () => setStep(1) : undefined}
      hideButton={step !== 3}
      buttonTitle={t('close') ?? 'Stäng'}
      onClickButton={() => navigate(RoutesEnum.Default)}
      content={
        <Box id='content-container' display='flex' flex={1} flexDirection='column'>
          <PurchaseForm
            setPurchaseData={(x: Purchase) => setPurchaseData(x)}
            setImageData={(arg: string) => setImageData(arg)}
            showForm={step === 1}
          />
          {data && (
            <PurchaseSummary
              data={data}
              imageData={imageData}
              showSummary={step === 2}
              onSubmitSuccess={() => setStep(3)}
            />
          )}
          {data && <PurchaseConfirmed data={data} showConfirmed={step === 3} onPressCreateAgain={() => setStep(1)} />}
        </Box>
      }
    />
  );
};

export default RegisterPurchase;
